import { SavedTranslation } from "src/common/api/apiTranslation";
import { makeDictionary } from "src/common/makeDictionary";
import { ZAttribute, ZAttributeValue } from "src/types/ZAttribute";
import { ZTranslation, ZTranslationMap } from "src/types/ZTranslation";
import { ZUid } from "src/types/zUid";

type DictValue = ZAttributeValue & {
  loc: ZTranslationMap;
};

export type EdDict = {
  name: string;
  values: DictValue[];
};

export const attr2edDict = (
  attr: ZAttribute,
  localValues?: ZTranslation[],
): EdDict => {
  const locDict = localValues
    ? makeDictionary(localValues, ({ value }) => value)
    : {};
  return {
    name: attr.name,
    values: (attr.values ?? []).map(({ id, value, sortOrder }) => ({
      id,
      value,
      sortOrder: sortOrder ?? null,
      loc: locDict[value ?? ""]?.translations ?? {},
    })),
  };
};

export const edDict2attr = (
  ed: EdDict,
  oldAttr: ZAttribute,
): {
  attr: Pick<ZAttribute, "name" | "values">;
  translations: SavedTranslation[];
} => {
  const { values, ...restAttr } = ed;
  const oldDict = (oldAttr.values ?? []).reduce(
    (acc, { id, value }) => ({ ...acc, [id]: value }),
    {} as Record<ZUid, string | null>,
  );
  return {
    attr: {
      ...restAttr,
      values: values.map(({ loc, ...restVal }) => restVal),
    },
    translations: values.map(({ loc, value, id }) => ({
      value: value || "",
      oldValue: oldDict[id] || "",
      translations: loc,
    })),
  };
};
